export enum SwapTab {
  Swap = 'swap',
  Limit = 'limit',
  Send = 'send',
  Bridge = 'bridge',
  Buy = 'buy',
}
